import SubmissionError from '../error/SubmissionError'
import { ENTRYPOINT } from '../config/entrypoint'

import store from '../store'

const MIME_TYPE = 'application/ld+json'

export default async function (id, options = {}) {
  if (typeof options.headers === 'undefined') Object.assign(options, { headers: new Headers() })

  if (options.headers.get('Accept') === null) options.headers.set('Accept', MIME_TYPE)

  if (store.getters['auth/tokenExpired']) {
    await store.dispatch('auth/checkSession')
  }

  let token = store.state.auth.accessToken
  options.headers.set('Authorization', `Bearer ${token}`)

  if (!options.headers.get('Accept-Language')) {
    options.headers.set('Accept-Language', 'en')
  }

  if (options.body !== undefined && !(options.body instanceof FormData) && options.headers.get('Content-Type') === null) {
    options.headers.set('Content-Type', MIME_TYPE)
  }

  const entryPoint = ENTRYPOINT + (ENTRYPOINT.endsWith('/') ? '' : '/')

  return fetch(new URL(id, entryPoint), options).then((response) => {
    if (response.ok) return response

    return response
      .json()
      .then((json) => {
        const error = json['hydra:description'] ? json['hydra:description'] : response.statusText
        if (!json.violations) throw Error(error)

        const errors = { _error: error }
        json.violations.map(violation =>
          Object.assign(errors, { [violation.propertyPath]: violation.message }))

        throw new SubmissionError(errors)
      })
  })
}
